import fotaApi from '@/api/api.fota'
import i18n from '@/locales'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Fota.deviceCode'),
    filed: 'deviceCode',
    default: ''
  },
  {
    type: 'input',
    placeholder: i18n.t('Fota.firmwareVersion'),
    filed: 'version',
    default: ''
  }
  // {
  //   type: 'select',
  //   placeholder: i18n.t('Fota.firmwareVersion'),
  //   filed: 'version',
  //   default: '',
  //   query: fotaApi.firmware_list + '?firmwareType=DTU',
  //   labelOptions: {
  //     key: 'version',
  //     value: 'version'
  //   }
  // }
]
